import React from 'react';
import { withRouter, BrowserRouter as Router } from  'react-router-dom';
import PropTypes from 'prop-types';

import { compose, withHandlers } from 'recompose';

import { connect } from 'react-redux';

import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import Routes from '../Components/Routes';
import Footer from '../Components/Footer';
import Header from '../Components/Header';

import { theme, commonStyles } from '../styles/styles';
import 'typeface-roboto';
import BreadCrumbArea from '../Components/BreadCrumbArea';
import { messageList } from '../redux/selectors';
import MessageList from '../Components/MessageList';
import ChangeProfilePopup from '../Components/Popups/ChangeProfilePopup';
import { selectUserPrograms, selectUserModule } from '../redux/reducers/userProgramsFull';
import { authUserRequest, getTokenFromCookies, logoutUserRequest } from '../redux/reducers/login';
import {getCoachesPrograms} from '../redux/selectors'
import CoachRatingPopup from '../Components/Popups/CoachRatingPopup';
import AddUserPopup from '../Components/Popups/AddUserPopup'
import DeleteUserPopup from '../Components/Popups/DeleteUserPopup';
import Notification from '../Components/Popups/Notification';
import AddCodePopup from '../Components/Popups/AddCodePopup';
import SaveEditPopup from '../Components/Popups/SaveEditPopup';

// const {whyDidYouUpdate} = require('why-did-you-update');
// whyDidYouUpdate(React);

const checkPath = (location, selectUserPrograms, selectUserModule) => {
  var paths = location.pathname.slice(1).split('/');
  // if(paths[1]){
  //  selectUserPrograms(parseInt(paths[1]))
  // }
  // if(paths[2]){
  //   selectUserModule(parseInt(paths[2]));
  // }
}
  

const App = ({ classes, showMessageCenter, showProfile, selectUserPrograms,selectUserModule, loginReducer, programs, showRating, view,...props }) => (
 
  <MuiThemeProvider theme={theme}>
  <div className="mainBg-grey"></div>
    {checkPath(props.location, selectUserPrograms, selectUserModule)}
    {}
    <div className="noView">
      <div className="z-depth-3  noView-container" >
        <div style={{height:30}} className="secondary-color w-100"></div>
        <div style={{padding: 10, fontSize: 13}}>
          This is better viewed in portrait.
        </div>
      </div>
      <div className="noView-bg"></div>
    </div>
    <div className="app-background">
      <div className={classes.root}>
    {loginReducer.user && <Header /> }
    {loginReducer.user  && <BreadCrumbArea /> }
        <Routes />
         <MessageList/>
        {showProfile &&  <ChangeProfilePopup/>} 
        {view.addProgrammePopup && <AddCodePopup />}
        <SaveEditPopup />
        <CoachRatingPopup/>
        <AddUserPopup />
        <DeleteUserPopup/>
        <Notification />
       
      </div>
      <Footer />
      
    </div>
    <div id="popup-container" />
  </MuiThemeProvider>
);

App.propTypes = {
  classes: PropTypes.instanceOf(Object),
};

const styles = () => ({
  ...commonStyles,
  root: {
    height:"100%",
    flexGrow: 1
  }
});

const mapStateToProps = state => ({
  showMessageCenter: state.messagesListReducer.showMessageCenterNow,
  coachFull: state.teamMembersFullReducer,
  showProfile: state.userProgramsFullReducer.showProfile,
  showRating: state.coachRatingReducer,
  loginReducer: state.loginReducer,
  programs: getCoachesPrograms(state),
  view: state.viewReducer,
});

const mapDispatchToProps = dispatch => ({
  logoutUserRequest: token => dispatch(logoutUserRequest(token)),
});


export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    handleTabValueChange: props => (event, value) => props.handleChangeTabValue(value),
  }),
  withStyles(styles),
)(App);



// WEBPACK FOOTER //
// ./src/Screens/App.jsx